import { apiGet, apiPost } from './client';

export type SmsCascadePrefetchCache = {
  create?: unknown;
  createApi?: unknown;
  subscribersParameters?: unknown;
  /** GET /api/viber/create */
  viberCreate?: unknown;
  /** GET /api/viber/create-api */
  viberCreateApi?: unknown;
  /** POST getparameters с channel=VIBER (динамические поля контактов) */
  viberSubscribersParameters?: unknown;
  /** GET /api/viber/check-alphanames */
  viberCheckAlphanames?: unknown;
  /** GET /api/viber/check-fee */
  viberCheckFee?: unknown;
  /** GET /api/email/getlistcontacts */
  emailGetlistcontacts?: unknown;
  /** GET /api/email/sendersconfirm */
  emailSendersconfirm?: unknown;
  /** GET /api/email/getcountemails */
  emailGetcountemails?: unknown;
  /** POST /api/email/templates (samples[]) */
  emailTemplates?: unknown;
};

let cache: SmsCascadePrefetchCache = {};
let inflight: Promise<void> | null = null;

async function safeGet<T>(path: string): Promise<T | undefined> {
  try {
    return await apiGet<T>(path);
  } catch {
    return undefined;
  }
}

async function safePost<T>(path: string, body: unknown): Promise<T | undefined> {
  try {
    return await apiPost<T>(path, body);
  } catch {
    return undefined;
  }
}

/** Кэш последнего префетча (для будущих селектов SMS в узлах). */
export function getSmsCascadePrefetchCache(): SmsCascadePrefetchCache {
  return { ...cache };
}

/**
 * Параллельно подгружает справочники SMS, Viber и Email у того же провайдера (ошибки отдельных GET игнорируются).
 */
export function prefetchSmsCascadeContext(): Promise<void> {
  if (inflight) return inflight;
  inflight = (async () => {
    const [
      create,
      createApi,
      subscribersParameters,
      viberCreate,
      viberCreateApi,
      viberSubscribersParameters,
      viberCheckAlphanames,
      viberCheckFee,
      emailGetlistcontacts,
      emailSendersconfirm,
      emailGetcountemails,
      emailTemplates,
    ] = await Promise.all([
      safeGet<unknown>('/api/sms/create'),
      safeGet<unknown>('/api/sms/create-api'),
      safeGet<unknown>('/api/sms/subscribers-parameters'),
      safeGet<unknown>('/api/viber/create'),
      safeGet<unknown>('/api/viber/create-api'),
      safeGet<unknown>('/api/sms/subscribers-parameters?channel=VIBER'),
      safeGet<unknown>('/api/viber/check-alphanames'),
      safeGet<unknown>('/api/viber/check-fee'),
      safeGet<unknown>('/api/email/getlistcontacts'),
      safeGet<unknown>('/api/email/sendersconfirm'),
      safeGet<unknown>('/api/email/getcountemails'),
      safePost<unknown>('/api/email/templates', {
        search: '',
        count: 200,
        offset: 0,
        direction: 'asc',
        order: 'id',
      }),
    ]);
    cache = {
      create,
      createApi,
      subscribersParameters,
      viberCreate,
      viberCreateApi,
      viberSubscribersParameters,
      viberCheckAlphanames,
      viberCheckFee,
      emailGetlistcontacts,
      emailSendersconfirm,
      emailGetcountemails,
      emailTemplates,
    };
  })().finally(() => {
    inflight = null;
  });
  return inflight;
}
